<script lang="ts">
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import {createEventDispatcher} from "svelte";
    import PagoAppSummaryBar from "./PagoAppSummaryBar.svelte";
    import {getFormatter} from "../../utils";
    import type {IPagoCard, IReglas} from "../../interfaces";

    const formatter = getFormatter();

    export let total = 0;
    export let data: Array<IPagoCard>;

    let dispatch = createEventDispatcher();

    let open = false;

    export let reglas:IReglas;



    $: selected = data ? data.map(e => {
        return {
            product: `${e.productLabel} ${e.productId} - endoso ${e.endoso}`,
            cuotas: e.cuotas.filter(c => c.selected).length
        };
    }) : [];

    function openFormas() {
        dispatch('formas');
    }

</script>
<div class="back-white radius py-1 px-15">
    <h2 style="font-weight: 400">Pagos a realizar</h2>
    <div class="py-1">
        {#each selected as pago}
            <p style="font-size:.9rem" class="mb-iii">{pago.product}<br>({pago.cuotas} cuotas)</p>
        {/each}
    </div>
    <p><strong>Total a pagar {formatter(total)}</strong></p>
    <div class="box py-15">
        <NauiButton caption="Continuar a pago" mode="solid" color="accent" on:click disabled={total <= 0}/>
    </div>
    {#if reglas.regla_1}
        <div class="box-l py-ii">
            <div class="alert success">
                <strong>ATENCIÓN: </strong>Usted cuenta con un saldo a favor que será descontado del pago de la póliza No. {reglas.regla_1}
            </div>
        </div>
    {/if}
    {#if total < 0} <!-- Regla 2 -->
        <div class="box-l py-ii">
            <div class="alert warning"><strong>ATENCIÓN: </strong>El valor total a pagar debe ser mayor a 0. Revise su selección para continuar</div>
        </div>
    {/if}
    {#if reglas.regla_4}
        <div class="box-l py-ii">
            <div class="alert warning"><strong>ATENCIÓN: </strong>El saldo a favor que está intentando seleccionar solo puede ser usado para pagos del mismo No. de póliza.<br>
                Esto sucede cuando se generan por una revocación por mora o terminación automática por no pago de prima.</div>
        </div>
    {/if}
    {#if reglas.regla_5 || reglas.regla_6}
        <div class="box-l py-ii">
            <div class="alert warning"><strong>ATENCIÓN: </strong>Tiene pagos asociados al mismo pagaré y con la misma fecha de vencimiento.
                Para poder realizar el pago debe cancelar todos los saldos que se encuentren pendientes bajo la misma fecha. {reglas.regla_5} {reglas.regla_6}</div>
        </div>
    {/if}
    {#if reglas.vencido}
        <div class="box-l py-ii">
            <div class="alert warning"><strong>ATENCIÓN: </strong>El pago extemporáneo de la prima no valida la mora, ni reactiva la póliza terminada.
                La compañía devolverá el monto de los dineros a que haya lugar, previa deducción de la prima devengada por el periodo que hubo cobertura.</div>
        </div>
    {/if}
    {#if reglas.regla_endosos}
        <div class="box-l py-ii">
            <div class="alert warning"><strong>ATENCIÓN: </strong>Seleccione los saldos a pagar en orden de vencimiento del más antiguo hacia adelante.</div>
        </div>
    {/if}
    {#if reglas.regla_tomador}
        <div class="box-l py-ii">
            <div class="alert warning"><strong>ATENCIÓN: </strong>No es posible seleccionar obligaciones con diferentes tomadores.</div>
        </div>
    {/if}
        {#if reglas.regla_preliquidacion}
        <div class="box-l py-ii">
            <div class="alert warning"><strong>ATENCIÓN: </strong>No es posible seleccionar una preliquidación en conjunto con otra obligación.</div>
        </div>
    {/if}
</div>
<br>
<div class="px-1 text-c formas-pago">
    <p style="font-size:.9rem">
        <strong>Formas de pago:</strong> Conozca las<br>
        <span class="secondary pointer" on:click={openFormas}>formas de pago</span>
        que se encuentran disponibles desde esta plataforma.
    </p>
</div>
<PagoAppSummaryBar {total} on:click/>

<style>
    @media (max-width: 1024px) {
        .formas-pago {
            margin-bottom: 90px;
        }
    }

    .alert {
        padding: 10px;
        border-radius: 8px;
    }

    .warning {
        background: #FFF7EA;
        border: 1px solid #FF8E27;
        color: #FF8E27;
        font-size: 15px;
    }

    .warning > * {
        color: #FF8E27;
    }

    .success {
        background: #f4f9ef;
        border: 1px solid #006729;
        color: #006729;
        font-size: 15px;
    }

    .success > * {
        color: #006729;
    }
</style>
